<template>
  <div class="card">
    <div class="exhibitContent zhanshang">
      <div class="catalogue">
        <span @click="()=>{this.$router.back()}"><img v-lazy="hrefurl+'/public/exhibit/exhibitor_back.png'" alt=""/></span>
        <div @click="()=>{this.$router.push('/newProducts')}" style="padding-bottom: 10px;cursor: pointer;">
          <img src="https://e.cippe.com.cn/public/images/sfsc1.jpg" alt="首发首创">
        </div>
        <div class="catalogueTitle">
          <img v-lazy="hrefurl+'/public/icon/zhanshang.png'" alt=""/>
          展馆分布图
          </div>
        <CataloguePavilion />
      </div>
      <div class="query">
        <div class="exhibitRight" type="text">
          <div class="rightBtn">
            <div>
              <el-select v-model="exhibitSort" placeholder="请选择展馆" @change="productSort">
                <el-option v-for="(item,i) in partitionArr" :key="i" :label="item.label_cn" :value="item.value_cn"></el-option>
              </el-select>
              <!-- <el-button @click="productSort">搜索</el-button> -->
            </div>
            <div>
              <el-input placeholder="请输入展商名称" v-model="exhibitName" @change="productName"></el-input>
              <el-button @click="productName">搜索</el-button>
            </div>
          </div>
        </div>
        <div class="queryNav" style="display:none">
          <span :class="flag==0?'flag':''" @click="demandSeek(0)">相关性 ↓</span>
          <span :class="flag==1?'flag':''" @click="demandSeek(1)">点击量 ↓</span>
          <span :class="flag==2?'flag':''" @click="demandSeek(2)">首字母 ↓</span>
        </div>
        <ExhorList 
          :tableData="tableData" 
          :page_key="page_key"  
          @amend="companyList" 
          @collect='collect'
          @make='make'
        />
        
      </div>
    </div>
    <div class="zxkf">
      <div class="divimg"></div>
      <p>联系我们</p>
      <!-- <img src="https://e.cippe.com.cn/public/images/onlineCustomerService.gif" alt=""> -->
      <div class="zxkfPopover">
        <!-- <div></div> -->
        如需咨询展商/展品，<br>
        请联系组委会索取资料！<br>
        电话：<span style="color: #008baf;">010-56176968</span>
      </div>
    </div>
  </div>
</template>

<script>
import CataloguePavilion from './cataloguePavilion'
import {reqExhibitorList } from '../../../api'
import ExhorList from "../../../components/pc/exhorList";
export default {
  components:{
    CataloguePavilion,
    ExhorList
  },
  data(){
    return{
      page_key:1,
      exhibitName:'',  //搜索
      exhibitSort:'',  //选择
      currentPage1: 1,  //当前页
      tableData: {list:[], listnum:0, pagelistnum:0, loading:true,},    //右侧数据
      flag:0,           //排序
      // catalogueList:[{url:"https://picsum.photos/id/446/200/200",index:1,title:"E1"},{url:"https://picsum.photos/id/446/200/200",index:1,title:"E1"},{url:"https://picsum.photos/id/446/200/200",index:1,title:"E1"},],  //左侧数据
      partitionArr:[
        {
          label_cn:'全部',
          label_en:'全部',
          value_cn:'',
          value_en:'',
        },
        {
          label_cn:'E1 展区',
          label_en:'E1 展区',
          value_cn:'E1',
          value_en:'E1',
        },
        {
          label_cn:'E2 展区',
          label_en:'E2 展区',
          value_cn:'E2',
          value_en:'E2',
        },
        {
          label_cn:'E3 展区',
          label_en:'E3 展区',
          value_cn:'E3',
          value_en:'E3',
        },
        {
          label_cn:'E4 展区',
          label_en:'E4 展区',
          value_cn:'E4',
          value_en:'E4',
        },
        {
          label_cn:'W1 展区',
          label_en:'W1 展区',
          value_cn:'W1',
          value_en:'W1',
        },
        {
          label_cn:'W2 展区',
          label_en:'W2 展区',
          value_cn:'W2',
          value_en:'W2',
        },
        {
          label_cn:'W3 展区',
          label_en:'W3 展区',
          value_cn:'W3',
          value_en:'W3',
        },
        {
          label_cn:'W4 展区',
          label_en:'W4 展区',
          value_cn:'W4',
          value_en:'W4',
        }
      ],
    }
  },
  methods: {
    async productSort(){// 选择搜索
      this.page_key_amend()
      this.companyList(1,this.flag,this.exhibitName,this.exhibitSort)
      this.currentPage1=1
    },
    
    productName(){// 搜索
      this.page_key_amend()
      this.companyList(0,this.flag,this.exhibitName,this.exhibitSort)
      this.currentPage1=1
    },
    
    demandSeek(index){// 排序
      this.page_key_amend()
      this.flag=index
      this.companyList(1,this.flag,this.exhibitName,this.exhibitSort)
      this.currentPage1=1
    },
    capitalizeLettersIfExist(str) {
      // 检查是否至少有一个英文字母
      if (/[a-zA-Z]/.test(str)) {
          // 将所有英文字母转为大写
          return str.replace(/[a-zA-Z]/g, match => match.toUpperCase());
      }
      return str; // 没有字母，原样返回
    },
    async companyList(page=1){// 请求展商列表
      this.tableData={
          list:[],
          listnum:0,
          pagelistnum:0,
          loading:true,
        }
      const response = await reqExhibitorList(page,this.exhibitSort,this.capitalizeLettersIfExist(this.exhibitName),)
      if(response.code==0){
        this.tableData={
          islogin:response.islogin,
          list:response.resilt,
          listnum:response.listnum,
          pagelistnum:response.pagelistnum,
          loading:false,
          thispage:response.thispage
        }
      }
      else{
        this.tableData={
          list:[],
          listnum:0,
          pagelistnum:0,
          loading:false,
        }
      }
    },
    
    async exhibitList(){// 左侧请求
      // const response = await reqMapList()
      // if(response.code==0)
        // this.catalogueList=response.data
    },

    page_key_amend(){
      this.page_key++
    },

    collect(ocid,coll){//收藏状态修改
     let i = this.tableData.list.findIndex((item)=>item.ocid==ocid)
      this.tableData.list[i].coll=coll
    },
    
    make(ocid,corp_app){//约见状态修改
      let i = this.tableData.list.findIndex((item)=>item.ocid==ocid)
      this.tableData.list[i].corp_app=corp_app
    }
    
  },
  mounted(){
    if (sessionStorage.getItem('merchant')) {
      let merchant = JSON.parse(sessionStorage.getItem('merchant'))
      this.exhibitName = merchant
      sessionStorage.removeItem('merchant')
    }
    if (sessionStorage.getItem('pavilion')) {
      let pavilion = JSON.parse(sessionStorage.getItem('pavilion'))
      this.exhibitSort = pavilion
      sessionStorage.removeItem('pavilion')
    }
    this.companyList()
    
  }

}
</script>

<style scoped>
  .card{
    max-width: 1200px;
    margin: 0 auto;
  }
  .exhibitContent{
    display: flex;
    justify-content: space-between;
    padding-bottom: 30px;
  }
  .catalogue{
    /* max-width: 282px; */
    max-width: 300px;
    width: 25%;
  }
  .catalogue>span{
    display: block;
    font-size: 26px;
    cursor: pointer;
    user-select: none;
    padding-left: 10px;
    padding-top: 22px;
    margin-bottom: 20px;
    width: 130px;
  }
  .catalogueTitle{
    width: 100%;
    height: 50px;
    font-size: 16px;
    line-height: 50px;
    background-color: #008baf;
    padding-left: 24px;
    color: #fff;
  }
  .catalogueTitle>img{
    width: 30px;
    vertical-align: middle;
  }

  /* 右 */
  .query{
    max-width: 894px;
    width: 74.0%;
    padding-top: 62px;
  }
  .exhibitRight, .exhibitRight>div{
    display: flex;
    justify-content: space-between;
    /* justify-content: end; */
  }
  .exhibitRight{
    margin-top: 36px;
    padding-bottom: 20px;
  }
  .exhibitRight>div{
    width: 100%;
  }

  .query>>>.el-input__inner,
  .query>>>.el-select-dropdown__item{
    color: #333;
  }
  .query >>>.el-input{
    width: auto;
  }
  .exhibitRight>div>>>input, .exhibitRight>div>>>select{
    width: 311px;
    height: 39px;
    font-size: 13px;
    padding: 0 14px;
    vertical-align: middle;
    border: 1px solid #dcdcdc;
  }
  .exhibitRight >>> .el-button,
  .exhibitRight >>> .el-input__inner{
    border: none;
    border-radius: 0;
    vertical-align: bottom;
    font-family: "microsoft yahei";
  }
  .rightBtn>div{
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #f08300;
  }
  .exhibitRight>div button{
    width: 86px;
    height: 39px;
    padding: 0;
    vertical-align: middle;
    background-color: #f08300;
    border: 0;
    color: white;
    font-size: 16px;
  }
  .el-button:focus, .el-button:hover{
    color: white;
    background-color: #f08300;
  }
  .queryNav{
    width: 100%;
    background-color: #fff;
    margin-bottom: 20px;
    font-size: 14px;
  }
  .queryNav>span{
    box-sizing: border-box;
    display: inline-block;
    text-align: center;
    line-height: 50px;
    width: 125px;
    /* height: 50px; */
    cursor: pointer;
    user-select: none;
  }
  .flag{
    border: 1px solid #008baf;
    color: #008baf;
  }
  
  @media (min-width: 992px) and (max-width: 1200px) {
     .exhibitRight>div>>>input, .exhibitRight>div>>>select{
      width: 270px;
    }
  }
  @media (min-width: 768px) and (max-width: 991.9px) {
    .catalogue{
      display: none;
    }
    .query{
      width: 100%;
      padding: 0 10px;
    }
    .exhibitRight>div>>>input, .exhibitRight>div>>>select{
      width: 270px;
    }
  }
</style>
<style scoped>
/* zxkf */
.zxkf{
    position: fixed;
    right: 0;
    top: 30%;
    width: 80px;
    height: 84px;
    color: #008baf;
    border-radius: 10px;
    box-shadow: 0 0 4px #ccc;
    transition: all .5s;
  }
  .zxkf .divimg{
    height: 64px;
    background: url(https://e.cippe.com.cn/public/images/service-blue.png) no-repeat;
    background-position: center;
  }
  .zxkf > p{
    text-align: center;
    font-size: 12px;
  }
  .zxkfPopover{
    opacity: 0;
    position: absolute;
    top: 0%;
    right: 80px;
    color: #000;
    width: 190px;
    height: 84px;
    padding: 10px;
    font-size: 14px;
    font-weight: bold;
    box-shadow: 0 0 4px #ccc;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    background-color: #fff;
    transition: all .5s;
  }
  .zxkf:hover{
    background-color: #008baf;
    color: #fff;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .zxkf:hover .divimg{
    background: url(https://e.cippe.com.cn/public/images/service-white.png) no-repeat;
    background-position-x: center;
    color: #fff;
  }
  .zxkf:hover .zxkfPopover{
    opacity: 1;
  }
</style>
